import React from 'react'
import { IonButton, IonButtons, IonFooter, IonToolbar } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import './QaFlagActionFooter.component.css'
import ExpandableTextarea from '../../../components/expandableTextarea/ExpandableTextarea.component'
import { useOfflineStatus } from '../../../utilities/isOnline.util'

export interface IQaFlagActionFooterProps {
  textareaLabel: string
  dataTestId: string
  value: string
  onChange: (value: string) => void
  maxLength: number
  isExpanded?: boolean
  onExpandedChange?: (expanded: boolean) => void
  primaryLabel: string
  canPrimary: boolean
  isCancelDisabled?: boolean
  onCancel: () => void
  onPrimary: () => void
  primaryTestId: string
}

const QaFlagActionFooter: React.FC<IQaFlagActionFooterProps> = ({
  textareaLabel,
  dataTestId,
  value,
  onChange,
  maxLength,
  isExpanded = false,
  onExpandedChange,
  primaryLabel,
  canPrimary,
  isCancelDisabled = false,
  onCancel,
  onPrimary,
  primaryTestId,
}) => {
  const { t } = useTranslation()
  const isOfflineStatus = useOfflineStatus()

  return (
    <IonFooter className={`qa-flag-action-footer${isExpanded ? ' qa-flag-action-footer-expanded' : ''}`}>
      <div
        className={`qa-flag-action-footer-textarea-wrap${
          isExpanded ? ' qa-flag-action-footer-textarea-wrap-expanded' : ''
        }`}>
        <ExpandableTextarea
          label={textareaLabel}
          dataTestId={dataTestId}
          value={value}
          onChange={onChange}
          maxLength={maxLength}
          isExpanded={isExpanded}
          onExpandedChange={onExpandedChange}
          className='qa-flag-textarea-field'
          inputClassName='qa-flag-input-shell qa-flag-input-shell-default'
        />
      </div>
      <IonToolbar color='light' className='qa-flag-action-footer-toolbar pt-10'>
        <IonButtons className='btn-grps'>
          <IonButton
            className='btn btn-secondary btn-tablet'
            expand='block'
            disabled={isCancelDisabled}
            onClick={onCancel}>
            {t('qaFlags.qaAddendum.flagResolution.cancel')}
          </IonButton>
          <IonButton
            className='btn btn-tablet btn-primary'
            expand='block'
            disabled={!canPrimary || isOfflineStatus}
            onClick={onPrimary}
            data-testid={primaryTestId}>
            {primaryLabel}
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonFooter>
  )
}

export default QaFlagActionFooter
